/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type careTeam_PlanCareTeam$ref = any;
export type CareTeamMemberInput = {|
  name?: ?string,
  roleCode: string,
|};
export type careTeam_createCareTeamMember_MutationVariables = {|
  planId: any,
  member: CareTeamMemberInput,
|};
export type careTeam_createCareTeamMember_MutationResponse = {|
  +careTeamMemberMutation: ?{|
    +createCareTeamMember: ?{|
      +$fragmentRefs: careTeam_PlanCareTeam$ref
    |}
  |}
|};
export type careTeam_createCareTeamMember_Mutation = {|
  variables: careTeam_createCareTeamMember_MutationVariables,
  response: careTeam_createCareTeamMember_MutationResponse,
|};
*/


/*
mutation careTeam_createCareTeamMember_Mutation(
  $planId: UUID!
  $member: CareTeamMemberInput!
) {
  careTeamMemberMutation {
    createCareTeamMember(planId: $planId, member: $member) {
      ...careTeam_PlanCareTeam
      id
    }
  }
}

fragment careTeam_PlanCareTeam on Plan {
  id
  careTeamMembers {
    id
    name
    primary
    role {
      id
      code
      value
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "member"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "member",
    "variableName": "member"
  },
  {
    "kind": "Variable",
    "name": "planId",
    "variableName": "planId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "careTeam_createCareTeamMember_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareTeamMemberMutation",
        "kind": "LinkedField",
        "name": "careTeamMemberMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "createCareTeamMember",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "careTeam_PlanCareTeam"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "careTeam_createCareTeamMember_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareTeamMemberMutation",
        "kind": "LinkedField",
        "name": "careTeamMemberMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "createCareTeamMember",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareTeamMember",
                "kind": "LinkedField",
                "name": "careTeamMembers",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CodeTablePair",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35f2ca8412d4aa21908fbc8cef733610",
    "id": null,
    "metadata": {},
    "name": "careTeam_createCareTeamMember_Mutation",
    "operationKind": "mutation",
    "text": "mutation careTeam_createCareTeamMember_Mutation(\n  $planId: UUID!\n  $member: CareTeamMemberInput!\n) {\n  careTeamMemberMutation {\n    createCareTeamMember(planId: $planId, member: $member) {\n      ...careTeam_PlanCareTeam\n      id\n    }\n  }\n}\n\nfragment careTeam_PlanCareTeam on Plan {\n  id\n  careTeamMembers {\n    id\n    name\n    primary\n    role {\n      id\n      code\n      value\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f2b7168b607e0a379f09eb61937a9dfa';

module.exports = node;
